export let stdapplinfColumns = () => {
  let pg3Columns = [{
    key: 'dteappl',
    name: '',
    labelCodapp: 'HRRC21P3',
    labelIndex: '10',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }, {
    key: 'codpos1',
    name: '',
    labelCodapp: 'HRRC21P3',
    labelIndex: '20',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'desc_codpos1',
    name: '',
    labelCodapp: 'HRRC21P3',
    labelIndex: '30',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'desc_codpos2',
    name: '',
    labelCodapp: 'HRRC21P3',
    labelIndex: '40',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'numappl',
    name: '',
    labelCodapp: 'HRRC21P3',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_statappl',
    name: '',
    labelCodapp: 'HRRC21P3',
    labelIndex: '60',
    style: 'min-width: 100px;'
  }, {
    key: 'numappr',
    name: '',
    labelCodapp: 'HRRC21P3',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_staappr',
    name: '',
    labelCodapp: 'HRRC21P3',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 100px;'
  }]

  let pg20t1Columns = [{
    key: 'numreqrq',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '20',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codposrq',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '30',
    style: 'min-width: 100px;'
  }, {
    key: 'dterec',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }, {
    key: 'numappr',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '60',
    style: 'min-width: 100px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }]

  let pg20t2Columns = [{
    key: 'numapseq',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codappty',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }, {
    key: 'dteappoi',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }, {
    key: 'qtyfscore',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'numgrd',
    name: '',
    labelCodapp: 'HRRC21P20',
    labelIndex: '130',
    class: 'align-center',
    style: 'min-width: 100px;'
  }]

  let pg7Columns = [{
    key: 'numseq',
    name: '',
    labelCodapp: 'HRRC21P7',
    labelIndex: '10',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'ti_codedlv',
    name: '',
    labelCodapp: 'HRRC21P7',
    labelIndex: '20',
    style: 'min-width: 200px;'
  }, {
    key: 'ti_coddglv',
    name: '',
    labelCodapp: 'HRRC21P7',
    labelIndex: '30',
    style: 'min-width: 100px;'
  }, {
    key: 'ti_codmajsb',
    name: '',
    labelCodapp: 'HRRC21P7',
    labelIndex: '40',
    style: 'min-width: 100px;'
  }, {
    key: 'ti_codinst',
    name: '',
    labelCodapp: 'HRRC21P7',
    labelIndex: '50',
    style: 'min-width: 100px;'
  }, {
    key: 'ti_codcount',
    name: '',
    labelCodapp: 'HRRC21P7',
    labelIndex: '60',
    style: 'min-width: 100px;'
  }]

  let pg8Columns = [{
    key: 'numseq',
    name: '',
    labelCodapp: 'HRRC21P8',
    labelIndex: '10',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'namchild',
    name: '',
    labelCodapp: 'HRRC21P8',
    labelIndex: '20',
    style: 'min-width: 200px;'
  }, {
    key: 'dtechbd',
    name: '',
    labelCodapp: 'HRRC21P8',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }, {
    key: 'ti_codsex',
    name: '',
    labelCodapp: 'HRRC21P8',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'ti_codedlv',
    name: '',
    labelCodapp: 'HRRC21P8',
    labelIndex: '50',
    style: 'min-width: 100px;'
  }]

  let pg9Columns = [{
    key: 'numseq',
    name: '',
    labelCodapp: 'HRRC21P9',
    labelIndex: '10',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desnoffi',
    name: '',
    labelCodapp: 'HRRC21P9',
    labelIndex: '20',
    style: 'min-width: 150px;'
  }, {
    key: 'desoffi1',
    name: '',
    labelCodapp: 'HRRC21P9',
    labelIndex: '30',
    style: 'min-width: 150px;'
  }, {
    key: 'deslstpos',
    name: '',
    labelCodapp: 'HRRC21P9',
    labelIndex: '40',
    style: 'min-width: 100px;'
  }, {
    key: 'dtestart',
    name: '',
    labelCodapp: 'HRRC21P9',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }, {
    key: 'dteend',
    name: '',
    labelCodapp: 'HRRC21P9',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }]

  let pg12Columns = [{
    key: 'numseq',
    name: '',
    labelCodapp: 'HRRC21P12',
    labelIndex: '10',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'destrain',
    name: '',
    labelCodapp: 'HRRC21P12',
    labelIndex: '20',
    style: 'min-width: 200px;'
  }, {
    key: 'dtetrain',
    name: '',
    labelCodapp: 'HRRC21P12',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }, {
    key: 'desplace',
    name: '',
    labelCodapp: 'HRRC21P12',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desinstu',
    name: '',
    labelCodapp: 'HRRC21P12',
    labelIndex: '50',
    style: 'min-width: 100px;'
  }]

  let pg13Columns = [{
    key: 'codtency',
    name: '',
    labelCodapp: 'HRRC21P13',
    labelIndex: '10',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'ti_codtency',
    name: '',
    labelCodapp: 'HRRC21P13',
    labelIndex: '20',
    style: 'min-width: 200px;'
  }, {
    key: 'fscore',
    name: '',
    labelCodapp: 'HRRC21P13',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'score',
    name: '',
    labelCodapp: 'HRRC21P13',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;'
  }]

  let pg14Columns = [{
    key: 'numseq',
    name: '',
    labelCodapp: 'HRRC21P14',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_typdoc',
    name: '',
    labelCodapp: 'HRRC21P14',
    labelIndex: '60',
    style: 'min-width: 100px;'
  }, {
    key: 'namdoc',
    name: '',
    labelCodapp: 'HRRC21P14',
    labelIndex: '10',
    style: 'min-width: 100px;'
  }, {
    key: 'filedoc',
    name: '',
    labelCodapp: 'HRRC21P14',
    labelIndex: '100',
    style: 'min-width: 100px;'
  }]

  return {
    en: {
      pg3: pg3Columns,
      pg20t1: pg20t1Columns,
      pg20t2: pg20t2Columns,
      pg7: pg7Columns,
      pg8: pg8Columns,
      pg9: pg9Columns,
      pg12: pg12Columns,
      pg13: pg13Columns,
      pg14: pg14Columns
    },
    th: {
      pg3: pg3Columns,
      pg20t1: pg20t1Columns,
      pg20t2: pg20t2Columns,
      pg7: pg7Columns,
      pg8: pg8Columns,
      pg9: pg9Columns,
      pg12: pg12Columns,
      pg13: pg13Columns,
      pg14: pg14Columns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/stdapplinf.js